import {
  DuplexObjectType,
  Field,
  InputFieldNullable,
  DuplexField,
  registerEnum
} from 'decapi'
import { ConstructorAssigner } from '../gql/ConstructorAssigner'
import { PositiveInt } from '@looop/graphql-scalars'
import GraphQLJSON from 'graphql-type-json'
import { DurationInputObject } from 'moment'
import { UserFilterComparatorOperator } from 'types/UserFilter'
import { GraphQLBoolean } from 'graphql'

export enum EnrolmentCreationMethodEnum {
  selfAssign = 'selfAssign',
  share = 'share',
  shareOrSelfAssign = 'shareOrSelfAssign'
}

registerEnum(EnrolmentCreationMethodEnum, {
  name: 'EnrolmentCreationMethodEnum'
})

export enum EnrolmentFilterTypeEnum {
  any_status = 'any_status',
  completed = 'completed',
  not_completed = 'not_completed',
  in_progress = 'in_progress',
  not_started = 'not_started',
  overdue = 'overdue',
  failed = 'failed',
  passed = 'passed',
  expires = 'expires',
  expired_or_expires = 'expired_or_expires',
  last_viewed_at = 'last_viewed_at',
  no_enrolment = 'no_enrolment',
  not_completed_or_no_enrolment = 'not_completed_or_no_enrolment'
}

registerEnum(EnrolmentFilterTypeEnum, {
  name: 'TargetEnrolmentStatusEnum'
})

export enum EventFilterTypeEnum {
  any_status = 'any_status',
  accepted = 'accepted',
  declined = 'declined',
  attended = 'attended',
  not_attended = 'not_attended',
  not_responded = 'not_responded'
}

registerEnum(EventFilterTypeEnum, {
  name: 'EventFilterTypeEnum'
})

export enum TimeDurationUnitsEnum {
  YEAR = 'YEAR',
  MONTH = 'MONTH',
  WEEK = 'WEEK',
  DAY = 'DAY',
  HOUR = 'HOUR'
}
registerEnum(TimeDurationUnitsEnum, {
  name: 'TimeDurationUnitsEnum'
})

@DuplexObjectType()
export class UserFilterTimeDuration {
  @DuplexField({ type: PositiveInt })
  multiplier?: number

  @DuplexField({ type: TimeDurationUnitsEnum })
  unit?: TimeDurationUnitsEnum
}

export enum TemporalDirection {
  BEFORE = 'BEFORE',
  AFTER = 'AFTER'
}

registerEnum(TemporalDirection, {
  name: 'TemporalDirection'
})

@DuplexObjectType()
export class RelativeTimeComparator {
  @DuplexField({ type: TemporalDirection })
  direction: TemporalDirection
  @DuplexField({ castTo: UserFilterTimeDuration })
  duration: UserFilterTimeDuration
}

@DuplexObjectType()
export class StaticTimeComparator {
  @DuplexField({ type: TemporalDirection })
  direction: TemporalDirection
  @DuplexField()
  date: Date
}

@DuplexObjectType()
export class RangeTimeComparator {
  @DuplexField()
  toDate: Date

  @DuplexField()
  fromDate: Date
}

@DuplexObjectType()
export class TimeComparatorForEnrolment {
  @DuplexField({ castTo: RelativeTimeComparator })
  relative: RelativeTimeComparator

  @DuplexField({ castTo: StaticTimeComparator })
  static: StaticTimeComparator

  @DuplexField({ castTo: RangeTimeComparator })
  range: RangeTimeComparator

  @DuplexField({ inputNullable: true })
  field: string
}

@DuplexObjectType()
export class UserFilterComparator {
  @DuplexField()
  operator: string
  @DuplexField({ type: GraphQLJSON })
  value: any
  @DuplexField({ inputNullable: true })
  field: string
}

export enum ArrayValueOperators {
  'in' = 'in',
  'not in' = 'not in',
  'contains' = 'contains'
}

export interface IUserFilterComparator {
  operator?: UserFilterComparatorOperator
  value?: string | number | null | DurationInputObject | string[]
  field?: string
}

@DuplexObjectType()
export class CampaignEnrolmentFilterSetup {
  @DuplexField({
    type: EnrolmentFilterTypeEnum,
    isNullable: false,
    inputNullable: false
  })
  enrolmentFilterType: EnrolmentFilterTypeEnum

  @DuplexField({ type: GraphQLBoolean })
  includeArchived: boolean

  @DuplexField({ type: EnrolmentCreationMethodEnum })
  creationMethod: EnrolmentCreationMethodEnum
}

@DuplexObjectType()
export class CampaignEventFilterSetup {
  @DuplexField({
    type: EventFilterTypeEnum,
    isNullable: false,
    inputNullable: false
  })
  eventFilterType: EventFilterTypeEnum

  @DuplexField({ type: [PositiveInt], isNullable: false, inputNullable: false })
  recurringEventIds: number[]

  @DuplexField({ type: [PositiveInt], isNullable: false, inputNullable: false })
  eventIds: number[]
}

export default class UserFilterBase extends ConstructorAssigner {
  type!: string

  @Field({ castTo: UserFilterComparator })
  @InputFieldNullable({ type: UserFilterComparator })
  comparator?: IUserFilterComparator | null

  @Field({ castTo: TimeComparatorForEnrolment })
  @InputFieldNullable({ type: TimeComparatorForEnrolment })
  temporalComparator?: TimeComparatorForEnrolment | null

  @DuplexField({ type: [PositiveInt], isNullable: true, inputNullable: true })
  ref_ids?: number[]

  @DuplexField({ isNullable: false, inputNullable: false })
  created_at: Date

  @DuplexField({ type: PositiveInt, inputNullable: false })
  created_by: number

  @DuplexField({ castTo: CampaignEnrolmentFilterSetup, inputNullable: true })
  enrolmentFilterSetup?: CampaignEnrolmentFilterSetup

  @DuplexField({ castTo: CampaignEventFilterSetup, inputNullable: true })
  eventFilterSetup?: CampaignEventFilterSetup
}
